import React from 'react';
import './Slider.css';

const Slider = ({ resource, title, link, index, articleIndex, totalItems }) => {
  // Вычисляем позицию слайда
  let position = 'nextSlide';
  
  if (articleIndex === index) {
    position = 'activeSlide';
  }
  
  if (articleIndex === index - 1 || (index === 0 && articleIndex === totalItems - 1)) {
    position = 'lastSlide';
  }

  return (
    <article className={`slider__container ${position}`}>
      <p className="slider__resource">{resource}</p>
      <p className="slider__title">{title}</p>
      <a 
        className="slider__link" 
        href={link} 
      >
        Link to the article
      </a>
    </article>
  );
};

export default Slider;